import React from 'react'
import './claimresources.scss'
import { images } from '../../../utils/customFn'
import { Row, Col } from 'react-bootstrap'
const ClaimResources = () => {
  return (
    <>
      <div className='resources-main'>
        <Row className='gy-5'>
          <Col sm={12} md={6} lg={6} xl={6}>
            <div className='left-details'>
              <div className='Heading'>
                <h3>For injured workers</h3>
              </div>
              <div className='text'>
                <p>Check your workers’ compensation claim details and find resources to help you through the recovery process. You’ll need to provide the claim number and your Social Security number.</p>
              </div>
              <button className='report-btn'>View claim details</button>
            </div>
          </Col>
          <Col sm={12} md={6} lg={6} xl={6}>
            <div className='image-media'>
              <img src={images['Warehouse-worker-injured-with-coworker.avif']} alt="media" />
            </div>
          </Col>
          <Col sm={12} md={6} lg={6} xl={6}>
            <div className='image-media'>
              <img src={images['Patient-meeting-with-medical-provider.avif']} alt="media" />
            </div>
          </Col>
          <Col sm={12} md={6} lg={6} xl={6}>
            <div className='left-details'>
              <div className='Heading'>
                <h3>For medical providers</h3>
              </div>
              <div className='text'>
                <p>Medical providers working with a patient with a workers’ compensation claim can submit bills online, sign up for electronic payments, and find state-specific information and payer IDs on our medical billing page.</p>
              </div>
              <button className='report-btn'>View medical provider resources</button>
            </div>
          </Col>
        </Row>
      </div>
    </>
  )
}

export default ClaimResources